import {Component, Inject, OnInit, Optional} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {filter} from 'rxjs';
import {IMaternityPeriod} from 'src/app/interfaces/maternity.interface';
import {DIALOG_DATA} from 'src/app/services/dialog.service';
import {DialogRef} from 'src/app/shared/ui-kits/dialog/dialog-ref';
import {Utils} from 'src/app/shared/utils/utils';
import {wordCountValidator} from 'src/app/validators/custom.validators';

@UntilDestroy()
@Component({
  selector: 'app-maternity-popup',
  templateUrl: './maternity-popup.component.html',
  styleUrls: ['./maternity-popup.component.scss'],
})
export class MaternityPopupComponent implements OnInit {
  public maternityForm!: UntypedFormGroup;
  public isoStartDate!: Date;
  public isDatePickerOpened!: boolean;

  constructor(
    private _fb: UntypedFormBuilder,
    private dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public data: IMaternityPeriod
  ) {}

  ngOnInit(): void {
    this.maternityForm = this._fb.group({
      comment: new UntypedFormControl(this.data.comment, [
        wordCountValidator(400),
      ]),
      employeeId: new UntypedFormControl(this.data.employeeId),
      startDate: new UntypedFormControl(this.data.startDate, [
        Validators.required,
      ]),
      endDate: new UntypedFormControl(this.data.endDate, [Validators.required]),
      id: new UntypedFormControl(this.data.id),
      type: new UntypedFormControl(this.data.type),
      paymentDate: new UntypedFormControl(
        this.data.paymentDate,
        Validators.required
      ),
      vacationDecision: new UntypedFormControl(1),
    });

    this.startDate.valueChanges
      .pipe(
        untilDestroyed(this),
        filter(data => data)
      )
      .subscribe(value => {
        this.isoStartDate = Utils.formatStringToDate(value);
      });
  }

  get startDate(): AbstractControl {
    return this.maternityForm.get('startDate')!;
  }

  save() {
    if (this.maternityForm.invalid) {
      Utils.validateAllFormFields(this.maternityForm);
      return;
    }
    this.dialogRef.close(this.maternityForm.value);
  }

  cancel() {
    this.dialogRef.close();
  }
}
